module.exports = __webpack_public_path__ + "static/media/Invalid.0344099e.svg";